import type { Int } from "@/types";

import { useParams } from "react-router";

import { isValidId } from "@/utilities/id";
import { getIntValue } from "@/utilities/number";

export const useIdParam = (): Int | undefined => {
  const { id: idParam } = useParams();
  const id = getIntValue(idParam ?? "");

  return isValidId(id) ? id : undefined;
};
